module.exports = __webpack_public_path__ + "img/cole.4fec755f.png";